/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutDashboard = createReactComponent("layout-dashboard", "IconLayoutDashboard", [
  ["path", { d: "M4 4h6v8h-6z", key: "svg-0" }],
  ["path", { d: "M4 16h6v4h-6z", key: "svg-1" }],
  ["path", { d: "M14 12h6v8h-6z", key: "svg-2" }],
  ["path", { d: "M14 4h6v4h-6z", key: "svg-3" }]
]);

export { IconLayoutDashboard as default };
//# sourceMappingURL=IconLayoutDashboard.js.map
